<script lang="ts">
  import Select from '@smui/select';
  import { createEventDispatcher, getContext } from 'svelte';
  const {
    catBrandFilter,
    catDiscountActiveFilters,
    categoryActiveFilters,
    catselectedPriceFilter,
    catsubFamilyFilter,
  } = getContext<any>('stores');

  import { getStr, globalCurrencyTag, isMobileWidth } from '../../../../common/util';
  import { formatPrice } from '../../../brand/services/brand-data-services';
  import ExtraCheckBox from '../../components/ExtraCheckBox.svelte';
  import ExtraFormField from '../../components/ExtraFormField.svelte';
  import Text from '../../components/Text.svelte';

  const dispatcher = createEventDispatcher();
  export let options;
  let valueHelperText = '';
  export let label = '';

  export let facetTypeClass = '';

  const handleClicksubFamily = data => {
    const selectedsubFamily = data;
    dispatcher('subfamilyFilterClicked', { selectedsubFamily });
  };

  function handleClick(e, data) {
    const rangeStart = data[0];
    const rangeEnd = data[data.length - 1];
    const priceFilterLabel = getStr('brand.price.range', [globalCurrencyTag, +rangeStart, +rangeEnd]);
    if (e.target.checked) {
      if (!$categoryActiveFilters.includes(priceFilterLabel)) {
        categoryActiveFilters.update(x => {
          x = [...$categoryActiveFilters, priceFilterLabel];
          return x;
        });
      }
    } else {
      $categoryActiveFilters = $categoryActiveFilters.filter(item => item !== priceFilterLabel);
    }
    dispatcher('priceFilterClicked', { rangeStart, rangeEnd });
  }

  const handleClickDiscount = data => {
    const rangeStart = data.min;
    const rangeEnd = data.max;
    dispatcher('discountFilterClicked', { rangeStart, rangeEnd });
  };

  const handleClickBrand = data => {
    const selectedBrand = data;
    dispatcher('brandFilterClicked', { selectedBrand });
  };

  function selectClosing(e) {
    if (isMobileWidth()) {
      const ele: any = e.target.closest('.filter-container');
      ele.style.overflowX = 'scroll';
    }
  }

  function selectOpen(e) {
    if (isMobileWidth()) {
      const ele: any = e.target.closest('.filter-container');
      ele.style.overflowX = 'clip';
    }
  }

  let catCheckboxSelected = '';

  $: {
    if (facetTypeClass === 'sub-family-facet') {
      catCheckboxSelected = $catsubFamilyFilter.length && 'selectedCheckbox';
    } else if (facetTypeClass === 'price-facet') {
      catCheckboxSelected = $catselectedPriceFilter.length && 'selectedCheckbox';
    } else if (facetTypeClass === 'discount-facet') {
      catCheckboxSelected = $catDiscountActiveFilters.length && 'selectedCheckbox';
    } else {
      catCheckboxSelected = $catBrandFilter.length && 'selectedCheckbox';
    }
  }
</script>

<section class="filter-tag-container">
  <div class="columns margins">
    <div>
      <Select
        class="shaped-outlined {catCheckboxSelected}"
        variant="outlined"
        bind:value={valueHelperText}
        {label}
        on:SMUIMenuSurface:closing={selectClosing}
        on:SMUIMenuSurface:opened={selectOpen}
      >
        {#each options as option}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          {#if label === getStr('extra.price.text')}
            <ExtraFormField>
              <div
                on:click={e => {
                  handleClick(e, option);
                }}
              >
                <ExtraCheckBox
                  bind:bindGroup={$catselectedPriceFilter}
                  value={`${+option[0]} - ${+option[option.length - 1]}`}
                />
              </div>
              <span class="filter-value"
                ><Text
                  key="brand.price.range"
                  args={[
                    `${globalCurrencyTag}`,
                    `${formatPrice(option[0])}`,
                    `${formatPrice(option[option.length - 1])}`,
                  ]}
                /></span
              >
            </ExtraFormField>
          {/if}
          {#if label === getStr('extra.filter.brand.title')}
            <ExtraFormField>
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                on:click={() => {
                  handleClickBrand(option);
                }}
              >
                <ExtraCheckBox bind:bindGroup={$catBrandFilter} value={`${option}`} />
              </div>
              <span class="filter-value">{option.toLowerCase()} </span>
            </ExtraFormField>
          {/if}

          {#if label === getStr('extra.filter.subfamily.title')}
            <ExtraFormField>
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                on:click={() => {
                  handleClicksubFamily(option);
                }}
              >
                <ExtraCheckBox bind:bindGroup={$catsubFamilyFilter} value={`${option}`} />
              </div>
              <span class="filter-value">{option} </span>
            </ExtraFormField>
          {/if}
          {#if label === getStr('extra.filter.discount.title') && option.n > 0}
            <ExtraFormField>
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                on:click={() => {
                  handleClickDiscount(option);
                }}
              >
                <ExtraCheckBox bind:bindGroup={$catDiscountActiveFilters} value={`${+option.min}% - ${option.max}%`} />
              </div>
              <span class="filter-value">{`${+option.min}% - ${option.max}%`} </span>
            </ExtraFormField>
          {/if}
        {/each}
      </Select>
    </div>
  </div>
</section>

<style lang="scss">
  @import '../../styles/colors.new.scss';

  .filter-tag-container {
    .filter-value {
      text-transform: capitalize;
      font-size: 14px;
    }
    @include desktop-max-width {
      :global(.mdc-select) {
        position: unset;
      }
    }
    * :global(.shaped-outlined),
    * :global(.shaped-outlined .mdc-select__anchor) {
      border-radius: 28px;
      height: 42px;
      background: $secondary-gray-02;
      z-index: 2;
    }
    * :global(.selectedCheckbox .mdc-select__anchor) {
      background: $neutral-dark-01;
    }

    * :global(.shaped-outlined .mdc-text-field__input) {
      padding-left: 32px;
      padding-right: 0;
    }
    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__leading) {
      border-radius: 28px 0 0 28px;
      width: 20px;
      border-right: none;
      border-left: 1px solid rgba(0, 0, 0, 0.38);
    }
    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__trailing) {
      border-radius: 0 28px 28px 0;
      border-right: 1px solid rgba(0, 0, 0, 0.38);
      border-left: none;
    }
    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__notch) {
      max-width: calc(100% - 28px * 2);
    }
    * :global(.shaped-outlined .mdc-notched-outline .mdc-notched-outline__notch .mdc-floating-label) {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      color: $neutral-dark-01;
    }
    * :global(.selectedCheckbox .mdc-notched-outline .mdc-notched-outline__notch .mdc-floating-label) {
      color: #fff;
    }
    * :global(.selectedCheckbox .mdc-notched-outline .mdc-notched-outline__notch .mdc-floating-label--float-above) {
      color: $neutral-dark-02;
    }
    *
      :global(
        .shaped-outlined.mdc-select--with-leading-icon
          .mdc-notched-outline:not(.mdc-notched-outline--notched)
          .mdc-floating-label
      ) {
      left: 16px;
    }
    * :global(.shaped-outlined .mdc-select__menu .mdc-deprecated-list div) {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      color: $neutral-dark-02;
      height: 20px;
    }

    * :global(.mdc-select--outlined .mdc-menu-surface) {
      border-radius: 10px;
      border: 1px solid $secondary-gray-02;
      background: $primary-white;
      width: 224px;
      box-shadow: 0px 4px 12px 0px rgba(219, 227, 232, 0.6);
      top: 56px !important;
    }
    * :global(.mdc-deprecated-list) {
      display: inline-flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      width: 100%;
      margin-top: 20px;
      max-height: 150px;
      overflow-y: auto;
    }

    * :global(.mdc-select--focused .mdc-menu-surface--open) {
      min-height: 150px;
      display: block;
      z-index: 2;
      @include desktop-max-width {
        z-index: 9;
        top: 190px !important;
      }
    }

    * :global(.mdc-select .mdc-select__menu .mdc-deprecated-list-item) {
      background-color: white;
    }
  }
</style>
